export default "__VITE_ASSET__DbWHSlz9__"